import { api } from "./index";

export interface EvaluationCriteria {
  id: string;
  tenderId: string;
  criteriaName: string;
  description?: string;
  criteriaType?: 'FINANCIAL' | 'GENERAL';
  weightage: number;
  order: number;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateEvaluationCriteriaDto {
  criteriaName: string;
  description?: string;
  criteriaType?: 'FINANCIAL' | 'GENERAL';
  weightage: number;
  order?: number;
  isDefault?: boolean;
}

export interface UpdateEvaluationCriteriaDto {
  criteriaName?: string;
  description?: string;
  criteriaType?: 'FINANCIAL' | 'GENERAL';
  weightage?: number;
  order?: number;
  isDefault?: boolean;
}

export const evaluationCriteriaApi = {
  // Create evaluation criteria
  createCriteria: (tenderId: string, data: CreateEvaluationCriteriaDto) =>
    api.post<EvaluationCriteria>(`/tenders/${tenderId}/evaluation-criteria`, data),

  // List evaluation criteria
  listCriteria: (tenderId: string) =>
    api.get<EvaluationCriteria[]>(`/tenders/${tenderId}/evaluation-criteria`),

  // Get evaluation criteria by ID
  getCriteriaById: (tenderId: string, criteriaId: string) =>
    api.get<EvaluationCriteria>(`/tenders/${tenderId}/evaluation-criteria/${criteriaId}`),

  // Update evaluation criteria
  updateCriteria: (tenderId: string, criteriaId: string, data: UpdateEvaluationCriteriaDto) =>
    api.put<EvaluationCriteria>(`/tenders/${tenderId}/evaluation-criteria/${criteriaId}`, data),

  // Remove evaluation criteria
  removeCriteria: (tenderId: string, criteriaId: string) =>
    api.delete(`/tenders/${tenderId}/evaluation-criteria/${criteriaId}`),

  // Create default evaluation criteria
  createDefaultCriteria: (tenderId: string) =>
    api.post<EvaluationCriteria[]>(`/tenders/${tenderId}/evaluation-criteria/default`),
};
